import formComp from './content';

export default formComp;
